// 配置公共参数
let locationUrl = 'ws://' + location.hostname + ':9053/websocket'; //地图websocket地址
let loginUrl = 'http://' + location.hostname + ":" + location.port; // 服务器地址
export default { locationUrl, loginUrl }
